#import "../fragments/next-steps-nutshell-notification-fragment.graphql"

mutation FormNextStepsNutshellNotificationDelete(
    $input: FormNextStepsNutshellNotificationDeleteInput!
) {
    formNextStepsNutshellNotificationDelete(input: $input) {
        nutshellNotification {
            ...NextStepsNutshellNotificationFragment
        }
    }
}
